<form fxLayout="column" 
    (submit)="changePassword()"
    [formGroup]="passwordForm"
    autocomplete="off"
  >
  <div class="login-form-flex">
    <mat-card>
      <mat-card-title class="text-center">
        <h2 class="text-center">Cambiar Contraseña</h2>
        <h5 class="text-center">Por favor ingrese su nueva contraseña, esta será modificada para su posterior ingreso al sistema</h5>
      </mat-card-title>
      <mat-card-content>
        <mat-form-field>
          <input matInput placeholder="Contraseña" type="password" name="access"
          formControlName="access">
        </mat-form-field>
        <br/>

      </mat-card-content>

      <mat-card-actions>
        <div class="button-flex-container">
          <button mat-raised-button color="primary" fxFlex="100%" [disabled]="this.passwordForm.invalid">ENVIAR</button>
        </div><br>
        <div class="button-flex-container">
          <button mat-raised-button color="primary" fxFlex="100%" (click)="backDasboard()">CANCELAR</button>
        </div>
      </mat-card-actions>
    </mat-card>
  </div>
</form>